import { setColorMode } from '@ui'

// Follows the viewer's OS light/dark setting. The UI layer maps it to the framework's own switch;
// the chart colours key off data-wl-theme (see index.css).
export function followSystemTheme() {
  const query = window.matchMedia('(prefers-color-scheme: dark)')
  const apply = () => setColorMode(query.matches ? 'dark' : 'light')
  apply()
  query.addEventListener('change', apply)
}
